<ng-container *ngIf="show">
    <!-- with custom font pack -->
    <ng-container *ngIf="customFontPack">
        <!-- font-awesome type -->
        <i [id]="'fa_'+widgetId" *ngIf="customFontPack?.type === 'font-awesome'"
            [class.rtl]="locale.getLangInfo()?.direction === 'rtl'"
            [class.ltr]="locale.getLangInfo()?.direction === 'ltr'" [class]="icon"></i>
        <!-- other icon types -->
        <nb-icon *ngIf="customFontPack?.type !== 'font-awesome'" [pack]="customFontPack?.name" [icon]="icon"></nb-icon>
    </ng-container>
    <!-- no custom font pack -->
    <ng-container *ngIf="!customFontPack">
        <!-- other icon types -->
        <nb-icon [icon]="icon"></nb-icon>
    </ng-container>

</ng-container>